/*eslint react-hooks/exhaustive-deps: "off"*/
import normalizeText from 'normalize-text';
import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

const normalizeValue = (val: unknown): Array<string | boolean> => {
  if (val == null) return [];

  if (typeof val === 'boolean') return [val];

  if (Array.isArray(val)) {
    return val
      .filter((v): v is string => typeof v === 'string')
      .map(v => normalizeText(v.toLowerCase()));
  }

  if (typeof val === 'string') {
    return [normalizeText(val.toLowerCase())];
  }

  return [];
};

const ShowOnWrapper = ({ children, input }) => {
  const { control } = useFormContext();

  const fieldValue = useWatch({
    control,
    name: input?.showOn?.codCore || input?.showOff?.codCore,
  });

  console.log(fieldValue);
  let visible = true;

  // ---------- SHOW ON ----------
  if (input.showOn) {

    if ((fieldValue === false || fieldValue === '') && input?.codCore !== 'otrosAccesorios') {
      return children;
    }

    const fieldValues = normalizeValue(fieldValue);
    const ruleValues = normalizeValue(input.showOn.value);

    visible = fieldValues.some(v => ruleValues.includes(v));
  }


  // ---------- SHOW OFF ----------
  if (input.showOff) {

    if ((fieldValue === false || fieldValue === '') && input?.codCore !== 'otrosAccesorios') {
      return children;
    }

    const fieldValues = normalizeValue(fieldValue);
    const ruleValues = normalizeValue(input.showOff.value);

    visible = !fieldValues.some(v => ruleValues.includes(v));
  }

  return visible ? children : null;
};

export default ShowOnWrapper;
